import React from 'react';
import AdminMasterLayout from '../../../layouts/gcadmin/adminMasterLayout/AdminMasterLayout';
import AdminDashboardPage from '../../../subsreens/gcadmin/admindashboardpage/AdminDashboardPage';


const GcAdminPage = () => {
    return(
        <AdminMasterLayout>
            <AdminDashboardPage></AdminDashboardPage>
        </AdminMasterLayout>
    )
}

export default GcAdminPage;